import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

import { useCartContext } from "../../context/CartContext.jsx";
import FormatPrice from "../../components/FormatPrice.jsx";

function ProductDetails() {
  const Base_URL = process.env.REACT_APP_BASE_URL;
  const Product_URL = process.env.REACT_APP_PRODUCT_URL;
  const Single_Product_API = `${Base_URL}${Product_URL}`;

  const [item, setItem] = useState("");
  const { id } = useParams();
  const { addToCart, addToOrder } = useCartContext();
  const [amount, setamount] = useState(1);

  const setDecrease = () => {
    amount > 1 ? setamount(amount - 1) : setamount(1);
  };

  const setIncrease = () => {
    amount < item.initial_stock
      ? setamount(amount + 1)
      : setamount(item.initial_stock);
  };

  useEffect(() => {
    const getSingleProd = async () => {
      const { data } = await axios.get(`${Single_Product_API}${id}/`);
      setItem(data);
    };
    getSingleProd();
  }, [Single_Product_API, id]);

  return (
    <>
      <section id="prodetails" className="section-p1">
        <div className="single-pro-img">
          <img id="mainImg" src={item.image} width="100%" alt="" />
        </div>

        <div className="col-md-8">
          <div className="card-body text-start">
            <h5 className="card-title my-2">{item.name}</h5>
            {/* <p className="card-text">{item.selling_price}</p> */}
            <div className="des" style={{ padding: "0px" }}>
              <span>
                Price:{" "}
                <del>
                  <b>
                    <FormatPrice price={item.selling_price} />
                  </b>
                </del>
              </span>
            </div>
            <div
              className="des"
              style={{ padding: "0px", marginBottom: "10px" }}
            >
              <span>
                Discount Price:{" "}
                <b>
                  <FormatPrice price={item.selling_price - item.discount} />
                </b>
              </span>
            </div>

            {item.initial_stock < 1 ? (
              <div className="detailsPtag_Btn my-3 mx-0">
                {/* <button onClick={() => setDecrease()}></button> */}
                <p
                  style={{ fontSize: "12px", fontWeight: "700", color: "red" }}
                  className="detailsPtagCount mb-3 mx-0"
                >
                  Out of stock
                </p>
                {/* <button onClick={() => setIncrease()}></button> */}
              </div>
            ) : (
              <div className="detailsPtag_Btn">
                <button onClick={() => setDecrease()}>-</button>
                <p className="detailsPtagCount">{amount}</p>
                <button onClick={() => setIncrease()}>+</button>
              </div>
            )}

            {/* <button className="btn btn-warning">Buy Now</button> */}
            <button
              className="normall mx-0"
              style={{ background: "green", border: "none" }}
              onClick={() => addToCart(item.id, amount, item)}
              disabled={item.initial_stock < 1}
            >
              Add to Cart
            </button>
            <div style={{ marginTop: "15px" }}>
              {/* <strong>Product Details:</strong> */}
              <div style={{ textAlign: "justify" }}>
                <div
                  dangerouslySetInnerHTML={{ __html: item.description }}
                ></div>
              </div>
            </div>
            <div className="text-center">
              <Link
                to="/order-checkout"
                onClick={() => {
                  addToOrder(item.id, amount, item);
                  setamount(1);
                }}
                className={`${item.initial_stock < 1 ? "disabled" : ""}`}
              >
                <button className="normalll">Order Now</button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductDetails;
